export default __webpack_public_path__ + "static/media/greenCrossplane.67b2e1f4.svg";